import React from 'react';
import BalanceFonctionnement from '../../components/simulation/Panels/BalanceFonctionnement';
import Panel from './Panel';

class BalanceFonctionnementPanel extends Panel {
	constructor() {
		super();
		this.code = 'BLC_FONC';
		this.icon = {
			iconSet: 'Lucide',
			name: 'BatteryCharging',
		};
		this.isMandatory = true;
		this.libelle = 'Balance de fonctionnement';
		this.size = 4;
	}

	getComponent = function getComponent(data: any): React.ReactElement {
		return <BalanceFonctionnement data={data} />;
	};
}

export default BalanceFonctionnementPanel;
